import {
  ChildCareTwoTone,
  FaceTwoTone,
  ManTwoTone,
  WomanTwoTone,
} from '@mui/icons-material';
import { SxProps } from '@mui/material';
import { adultAgeInMonths, childAgeInMonths } from '../constants';

export function AgeGroupIcon({
  sx,
  ...props
}: {
  startMonths: number;
  gender: 'MALE' | 'FEMALE';
  sx?: SxProps;
}) {
  const extraProps = { sx };

  if (props.startMonths < childAgeInMonths)
    return <ChildCareTwoTone {...extraProps} />;
  if (props.startMonths < adultAgeInMonths)
    return <FaceTwoTone {...extraProps} />;
  return props.gender === 'MALE' ? (
    <ManTwoTone {...extraProps} />
  ) : (
    <WomanTwoTone {...extraProps} />
  );
}
